import React from 'react';
import PlaceholderPage from '../components/PlaceholderPage';

const Settings = () => <PlaceholderPage title="설정" description="매장 정보와 운영 설정을 관리해요." />;

export default Settings;
